import type { KeyboardEvent } from "react";

import { callAll } from "../../../../utils/call-all";
import { useSearchMenuContext } from "../../search-menu.context";
import type { SearchMenuListProps, SearchMenuListViewProps } from "./types-list";

/** ViewModel do SearchMenu.List: teclado entre os itens somado (`callAll`) ao `onKeyDown` da tela; sem JSX. */
export function useSearchMenuList({
  label,
  className,
  children,
  onKeyDown,
  ...rest
}: SearchMenuListProps): SearchMenuListViewProps {
  const { onListKeyDown } = useSearchMenuContext();

  return {
    label,
    className,
    onKeyDown: callAll<[KeyboardEvent<HTMLUListElement>]>(onListKeyDown, onKeyDown),
    rest,
    children,
  };
}
